<h1>La solicitud tardó demasiado tiempo </h1>
<div>
    Vuelve a intentarlo
</div>
<div>
    <button mat-button mat-dialog-close color="primary">Cerrar</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
</div>
